import request from './api';
import {
  API_SEND_EMAIL_IRPF,
  API_SEND_EMAIL_IRPF_ADMIN,
  API_SEND_EMAIL_SEARCH_ID,
  API_SEND_EMAIL_USERS_DEREGISTRATION,
  API_SEND_EMAIL_USERS_REGISTRATION,
  API_USER,
  API_USER_ADMIN
} from '../constants/api';

export const getUserIrpfYears = employeeId =>
  request(`${API_USER}irpf`, {
    method: 'GET',
    params: { employeeId }
  });

export const getIrpfByYearLink = (year, managedUserId, token, nif) =>
  request(
    `${API_USER}irpf`,
    {
      method: 'GET',
      responseType: 'blob',
      params: { year, managedUserId, token, nif }
    },
    false
  );

export const getIrpfByDNI = (userId, year, dni, tokenMail) =>
  request(
    `${API_USER_ADMIN}irpf/dni`,
    {
      method: 'GET',
      responseType: 'blob',
      params: { userId, year, dni, tokenMail }
    },
    false
  );

export const sendEmailIrpf = data =>
  request(API_SEND_EMAIL_IRPF, {
    method: 'POST',
    data
  });

export const sendEmailIrpfAdmin = data =>
  request(API_SEND_EMAIL_IRPF_ADMIN, {
    method: 'POST',
    data
  });

export const sendEmailUsersRegistration = () =>
  request(API_SEND_EMAIL_USERS_REGISTRATION, {
    method: 'POST'
  });

export const sendEmailUsersDeregistration = () =>
  request(API_SEND_EMAIL_USERS_DEREGISTRATION, {
    method: 'POST'
  });

export const getUserBySearchID = userId =>
  request(API_SEND_EMAIL_SEARCH_ID, {
    method: 'GET',
    params: { userId }
  });
